"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineLabels = combineLabels;
function combineLabels(source) {
    const reduced = source.reduce((acc, { value, label }) => {
        const existing = acc.find((item) => item.label === label);
        if (existing) {
            if (Array.isArray(existing.value)) {
                if (Array.isArray(value)) {
                    existing.value.push(...value);
                }
                else {
                    existing.value.push(value);
                }
            }
            else {
                if (Array.isArray(value)) {
                    existing.value = [existing.value, ...value];
                }
                else {
                    existing.value = [existing.value, value];
                }
            }
        }
        else {
            acc.push({ value, label });
        }
        return acc;
    }, []);
    return reduced;
}
//# sourceMappingURL=combine-labels.js.map